import { PixelCrop } from "react-image-crop";

export function canvasPreview(
    image: HTMLImageElement,
    crop: PixelCrop,
    targetWidth: number,
    targetHeight: number
): string {
    const canvas = document.createElement("canvas");

    const ctx = canvas.getContext("2d");

    if (!ctx) {
        throw new Error("No 2d context");
    }

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const cropWidth = (crop.width) * scaleX;
    const cropHeight = (crop.height) * scaleY;

    canvas.width = targetWidth <= cropWidth ? targetWidth : cropWidth;
    canvas.height = targetHeight <= cropHeight ? targetHeight : cropHeight;

    ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        (crop.width) * scaleX,
        (crop.height) * scaleY,
        0, 0, canvas.width, canvas.height);

    return canvas.toDataURL("image/jpeg");
}
